import { useContext, useEffect, useRef, useState } from 'react'
import { ReadableCategories, ReadableFilters } from 'generated/apolloComponents'
import { MinusIcon, PlusIcon } from '@heroicons/react/24/solid'
import CategoryListItem from '../../atoms/CategoryListItem'
import styles from './CategoryList.module.scss'
import {
  ActionType,
  BlogContext,
  BlogStateFilters,
} from '@/context/blogContext'

interface IProps {
  className: string
  categories: any
}

const CategoryList = ({ className, categories }: IProps) => {
  const { state, dispatch } = useContext(BlogContext)

  const refWrapper = useRef<HTMLDivElement>(null)
  const refInner = useRef<HTMLDivElement>(null)
  const [advanced, setAdvanced] = useState(false)
  const [expanded, setExpanded] = useState(false)

  const handleCategoryChange = (e: React.MouseEvent) => {
    const target = e.target as HTMLButtonElement
    const value = target.value as ReadableCategories
    const tmpFilters: ReadableFilters = { ...state.filters }
    let specFilter = tmpFilters[target.name as keyof ReadableFilters]

    if (Array.isArray(specFilter)) {
      if (specFilter.includes(value)) {
        specFilter = specFilter.filter((ele) => ele != target.value)
      } else {
        specFilter.push(value)
      }
    } else {
      specFilter = []
      specFilter.push(value)
    }

    dispatch({
      type: ActionType.ChangeFilter,
      payload: { ...state.filters, [target.name]: specFilter },
    })
  }

  useEffect(() => {
    const wrapperWidth: number | undefined = refWrapper.current?.offsetWidth
    const innerWidth: number | undefined = refInner.current?.offsetWidth

    if (wrapperWidth && innerWidth && +wrapperWidth < +innerWidth)
      setAdvanced(true)
  }, [])

  const handleExpandClick = (e: React.MouseEvent) => {
    setExpanded(!expanded)
  }

  const isActive = (filter: keyof BlogStateFilters, value: string) =>
    state.filters && state.filters[filter]?.includes(value as any)

  return (
    <div className={`relative ${className || ''}`}>
      <div
        className={`${styles.categoryList__wrapper} ${
          expanded ? styles['categoryList--expanded'] : ''
        } ${advanced ? styles['categoryList--advanced'] : ''}`}
        ref={refWrapper}
      >
        <div className={`${styles.categoryList__inner}`} ref={refInner}>
          {!expanded &&
            categories[0].data.map((item: any, index: number) => (
              <CategoryListItem
                key={index}
                title={item.title}
                onClick={handleCategoryChange}
                value={item.key}
                name='categories'
                active={isActive(
                  categories[0].taxonomy.key as keyof BlogStateFilters,
                  item.key
                )}
              />
            ))}

          {expanded && (
            <>
              {categories.map((term: any, index: number) => (
                <div key={index} className='mb-10'>
                  <h6 className='uppercase tracking-widest font-bold mb-2'>
                    {term.taxonomy.title}
                  </h6>
                  {term.data.map((item: any, termIdx: number) => (
                    <CategoryListItem
                      key={termIdx}
                      title={item.title}
                      onClick={handleCategoryChange}
                      value={item.key}
                      name={term.taxonomy.key}
                      active={isActive(
                        term.taxonomy.key as keyof BlogStateFilters,
                        item.key
                      )}
                    />
                  ))}
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <button
        type='button'
        className={`${styles.categoryList__button}`}
        onClick={handleExpandClick}
      >
        {expanded ? <MinusIcon width='15' /> : <PlusIcon width='15' />}
      </button>
    </div>
  )
}
export default CategoryList
